import React,{useState,useEffect} from "react"


import DateUtil from "../../common/dateUtil";
import LoadingComp from "../common/LoadingComp";

import PopupDialog from "./controls/PopupDialog";

import PreTradeDetailComp from "../pretrade/PreTradeDetailComp"
import ObaDetailComp from "../oba/ObaDetailComp";
import GiftDetailComp from "../gift/GiftDetailComp";
import PoliticalDetailComp from "../political/PoliticalDetailComp";
import DocumentDetailComp from "../documents/DocumentDetailComp";

import { fetchCall } from "../../common/FetchHelpers";

import PreTradeEditorComp from "../pretrade/PreTradeEditorComp";

import ObaEditorComp from "../oba/ObaEditorComp";
import GiftEditorComp from "../gift/GiftEditorComp";
import PoliticalEditorComp from "../political/PoliticalEditorComp";
import DocumentEditor from "../documents/DocumentEditor";


const DetailPopup = (props)=>{
    const finInstituteUrl = "api/trade-request/finInstitute";
    const accountUrl = "api/user-account/UserAccounts";


    const [editing,setEditing] = useState(false);
    const [data,setData] = useState(props.data);
    
    const [editorItem,setEditorItem] = useState({});

    const [loading, setLoading] = useState(false);
    const [reloadList, setReloadList] = useState(false);
    
    const [showSecurity, setShowSecurity] = useState(false);
    const [showOba, setShowOba] = useState(false);
    const [showGift, setShowGift] = useState(false);
    const [showPolitical, setShowPolitical] = useState(false);
    const [showDocument, setShowDocument] = useState(false);

    const [metadata, setMetadata] = useState({});

    const handleReloadItem = (id)=>{
        console.log(`Reloading ${id}`);
        loadItem();
        setReloadList(true);
    }


    const loadItem = ()=>{
    
            setLoading(true);
            const url = `api/${props.data.reqType !== "Security" ? props.data.reqType:"trade-request"}/details/${props.data.id}`;

            fetchCall(url)
                .then((result)=>{
                    setLoading(false);
                    
                    if(result){
                        result.formData = JSON.parse(result.formData);
                        if(props.data.template){
                            result.template = props.data.template;
                        }
                        else if(result.templateStr){
                            result.template = {};
                            result.template.templateStr = result.templateStr;
                        }
                        result = {...result, ...result.formData}
        
                        if(props.data.reqType === "oba"){
                            result.isClientOwnSecurity = result.clientAccount?"Yes":"No";
                            result.isFundraising = result.fundraisingDesc?"Yes":"No";
                            result.isBusinessCustody = result.businessCustody?"Yes":"No";
                            result.rdoPartnerType = (result.partnerType === "General" ||result.partnerTyp === "Limited" )?result.partnerType:"Other";                    
        
                            if(result.solicitedInvestors && result.solicitedInvestors.length>0){
                                result.solicitedInvestors.map(p=>p.investmentDate = (p.investmentDate)?new Date(p.investmentDate):"");
                            }
                            else {
                                result.solicitedInvestors = [{investorName:"",investorRelation:"",investmentAmount:"",investmentDate:"",involvementType:""}];
                            }
                
                            if(!result.activityInvolvedPeople || result.activityInvolvedPeople.length===0){
                                result.activityInvolvedPeople = [{name:"",accountNumbers:"",involvementType:""}];
                            }
                        }
                        if(props.data.reqType === "Security"){
                            result.isPassiveInvestor = result.passiveInvolvement?"Yes":"No",
                            result.isClientInvolve = result.clientInvolvement?"Yes":"No",
                            result.isPublicBusiness = result.publicTradeEntity?"Yes":"No",
                            result.isBusinessCustody = result.businessCustody?"Yes":"No",
                            result.isCapitalRaise = result.capitalRaiseDesc?"Yes":"No",
                            result.isOwnershipBeneficial = result.isOwnershipBeneficial?"Yes":"No"
                        }
                    }
                    console.log(result);
        
                    setData(result);
        
                    setShowOba(props.data.reqType === "oba");
                    setShowGift(props.data.reqType === "gift");
                    setShowPolitical(props.data.reqType === "political");
                    setShowDocument(props.data.reqType === "Document");
                    setShowSecurity(props.data.reqType === "Security");
                },
                (err)=>{
                    setLoading(false);
                }
            );
    };
    
    const handleUpdate = ()=>{

        if(showOba){
           
            const activityStartDate = DateUtil.toDate(data.activityStartDate);
            const item = {
            ...data,
            activityStartDate,
            isBusinessCustody:data.businessCustody?"Yes":"No",
            businessCustody:data.businessCustody===null?"":data.businessCustody
            };
    
            setEditorItem(item);

        } else if(showPolitical){
                const contribDate = DateUtil.toDate(data.contribDate);
                const electionDate = data.electionDate?DateUtil.toDate(data.electionDate):null;
                const individualPriorContribDate = data.individualPriorContribDate?DateUtil.toDate(data.individualPriorContribDate):null;
                
                const item = {
                ...data,
                contribDate,
                electionDate,
                individualPriorContribDate,
                isCampaign:data.campaign===null?"N":"Y",
                    campaign:data.campaign===null?"":data.campaign
                };

                setEditorItem(item);

            } else if(showGift) {
                const giftDate = DateUtil.toDate(data.giftDate);
                const item = {
                  ...data,
                  giftDate,
                  isGovRecipients:data.governmentRecipients===null?"N":"Y",
                  governmentRecipients:data.governmentRecipients===null?"":data.governmentRecipients,
                  isRaffleContest:data.raffleContest===null?"N":"Y",
                  raffleContest:data.raffleContest===null?"":data.raffleContest
                };
             
                setEditorItem(item);

            } else if (showSecurity){
                //const tradeDate = DateUtil.toDate(data.tradeDate);
                const item = {
                    ...data,
                    account:{ accountNumber: data.accountNumber, brokerDealerName: data.finInstitute },
                    tradeDate:data.tradeDate
                };
                setEditorItem(item);

            }

        setEditing(true);
        
    };




    const getUserAccounts = () => {

        fetchCall(accountUrl)
            .then((result)=>{
                setMetadata({ ...metadata, accounts: result });

            },
            (err)=>{
                console.log(err);
            }
        );
    }

    const getFinancialInstitutes =()=>{

        fetchCall(finInstituteUrl)
            .then((result)=>{
                setMetadata({ ...metadata, finInstitute: result });
            },
            (err)=>{
                console.log(err);
            }
        );
    }

   useEffect(()=>{
       loadItem();

       if(props.data.reqType === "Security"){
           getUserAccounts();
           getFinancialInstitutes();
       }

   },[]);

    return (
        <PopupDialog handleClose={props.handleClose}>

            {props.data.reqType === "Security" && !editing && (
                <PreTradeDetailComp data={data} title="Details" reloadItem={handleReloadItem} handleUpdate={handleUpdate} handleClose={p=>props.handleClose(reloadList)} metadata={props.metadata}/>
            )}

            {showOba && !editing && (
                <ObaDetailComp data={data} title="Details" reloadItem={handleReloadItem} handleUpdate={handleUpdate} handleClose={p=>props.handleClose(reloadList)}/>
            )}

            {showGift && !editing && (
                <GiftDetailComp data={data} title="Details" reloadItem={handleReloadItem} handleUpdate={handleUpdate} handleClose={p=>props.handleClose(reloadList)}/>
            )}

            {showPolitical && !editing && (
                <PoliticalDetailComp data={data} title="Details" reloadItem={handleReloadItem} handleUpdate={handleUpdate} handleClose={p=>props.handleClose(reloadList)}/>
            )}

            {showDocument && !editing && (
                <DocumentDetailComp editorItem={data} title="Details" reloadItem={handleReloadItem} handleUpdate={handleUpdate} handleClose={p=>props.handleClose(reloadList)}/>
            )}


            {showSecurity && editing && (
                <PreTradeEditorComp handleClose={p=>props.handleClose(true)} formData={editorItem} metadata={metadata} editorMode="UPDATE"/>
            )}

            {showOba && editing && (
                <ObaEditorComp handleClose={p=>props.handleClose(true)} formData={editorItem} editorMode="UPDATE"/>
            )}

            {showGift && editing && (
                <GiftEditorComp handleClose={p=>props.handleClose(true)} formData={editorItem} editorMode="UPDATE"/>
            )}

            {showPolitical && editing && (
                <PoliticalEditorComp handleClose={p=>props.handleClose(true)} formData={editorItem} editorMode="UPDATE"/>
            )}

            {showDocument && editing && (
                <DocumentEditor handleClose={p=>props.handleClose(true)} editorItem={data} editorMode="UPDATE"/>
            )}

            {loading && <LoadingComp />}

            
          </PopupDialog>
    )
}


export default DetailPopup;